import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import Swal from 'sweetalert2';
import { BrdsqlService } from '../../../services/brdsql.service';
import { AppServiceService } from '../../../services/app-service.service';
import * as XLSX from 'xlsx';
declare var $: any;

@Component({
  selector: 'app-emp-position',
  templateUrl: './emp-position.component.html',
  styleUrls: ['./emp-position.component.css']
})
export class EmpPositionComponent implements OnInit {

  formEdit?= false;
  jobData?: any[];
  jobEdit?: any = [];
  depData?: any = [];

  fileName = 'jobTitleBRD.xlsx';
  @ViewChild('tb_data') tb_data!: ElementRef;
  @ViewChild('frm_addJob') frm_addJob: NgForm;

  constructor(
    private brdservice: BrdsqlService,
    private appservice: AppServiceService,
  ) { }

  ngOnInit(): void {
    this.depList()
    this.jobtitleList()
  }

  async depList() {
    this.depData = null;
    await this.brdservice.departmentList()
      .subscribe({
        next: (data: any) => {
          this.depData = data.recordset;
          // console.log('department data: ', this.departmentData);
        }
      })
  }

  async jobtitleList() {
    await this.brdservice.jobtitleList()
      .subscribe({
        next: (data: any) => {
          this.jobData = data.recordset;
          console.log('jobData : ', this.jobData);
        }
      })
  }

  // บันทึกฟอร์มเพิ่มข้อมูลตำแหน่งงาน
  saveAddJob(f: any) {
    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      // text: 'You will not be able to recover this file!',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.brdservice.saveAddJob(f)
          .subscribe({
            next: (data: any) => {
              console.log('response:', data);
              if (data.rowsAffected == 1) {
                Swal.fire('บันทึกข้อมูลสำเร็จ!', 'success')
                this.jobtitleList();
              } else {
                Swal.fire({ icon: 'error', title: 'Oops...', text: 'บันทึกข้อมูลไม่สำเร็จ!', footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>' })
              }
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          'cancle'
        )
      }
    })
  };

  editJob(dataid:string) {
    this.formEdit = true;  // สถานะเป็นฟอร์มแก้ไข
    this.jobEdit = this.jobData.filter((el: { dataid: any; }) => el.dataid == dataid);
    this.jobEdit = this.jobEdit[0];
    // console.log('depEdit ' ,this.depEdit);
  }

  // บันทึกการแก้ไขข้อมูลตำแหน่งงาน
  saveEditJob(f: any) {
    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.brdservice.updateJob(f)
          .subscribe({
            next: (data: any) => {
              console.log('response:', data);
              if (data.rowsAffected == 1) {
                Swal.fire('บันทึกข้อมูลสำเร็จ!', 'success')
                this.jobtitleList();
                this.resetFormAddJob()
              } else {
                Swal.fire({ icon: 'error', title: 'Oops...', text: 'บันทึกข้อมูลไม่สำเร็จ!', footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>' })
              }
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          'cancle'
        )
      }
    })
  };

  resetFormAddJob() {
    this.frm_addJob.reset()
    this.formEdit = false;
  }

  exportExcel(): void {
    {
      /* table id is passed over here */
      let element = document.getElementById('position-table');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      XLSX.writeFile(wb, this.fileName);

    }
  }  

  numberOnly(event:any) {
    this.appservice.numberOnly(event)
  }

}
